import { render, staticRenderFns } from "./MovimientoCrud.vue?vue&type=template&id=5d42a00e&"
import script from "./MovimientoCrud.vue?vue&type=script&lang=js&"
export * from "./MovimientoCrud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports